import { update } from './update';
import addError from '../../../utils/error.jsx';

export function request( sportId, participant ) {
    return {
        type: 'PARTICIPANT_UPDATED_REQUEST',
        sportId,
        participant
    };
}

export function error( sportId, errors ) {
    addError( errors );
    return {
        type: 'PARTICIPANT_UPDATED_ERROR',
        sportId,
        errors
    };
}

export function finish( sportId, participant ) {
    return ( dispatch ) => {
        dispatch( update( participant.id, participant ) );

        dispatch( {
            type: 'PARTICIPANT_UPDATED_FINISH',
            sportId,
            participant
        } );
    };
}
